import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/types';

import { amlbotAPI } from '@/api';
import type {
  AmlHistoryResponse,
  AmlHistoryRequest,
  GetAmlHistoryItemRequest,
  GetAmlHistoryItemResponse,
} from '@/api';
import { parseError } from '@/redux/helpers';
import { amlHistoryActions } from '@/redux/actions';
import { amlHistoryMappers } from '@/redux/mappers';

function* fetchAmlHistory(
  action: PayloadAction<AmlHistoryRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const response: AmlHistoryResponse = yield call(
      amlbotAPI.fetchAmlHistory,
      payload,
    );
    const data = amlHistoryMappers.amlHistory(response);

    const isShowMoreRequest = 'page' in payload;

    if (isShowMoreRequest) {
      yield put(amlHistoryActions.addData(data));
    } else {
      yield put(amlHistoryActions.setData(data));
    }
  } catch (error: unknown) {
    const { message } = parseError(error);
    yield put(amlHistoryActions.setError(message));
  } finally {
    yield put(amlHistoryActions.setLoading(false));
  }
}

function* fetchHistoryItem(
  action: PayloadAction<GetAmlHistoryItemRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const response: GetAmlHistoryItemResponse = yield call(
      amlbotAPI.fetchAmlHistoryItem,
      payload,
    );

    const item = amlHistoryMappers.mapAmlHistoryItem(response.data.data);
    yield put(amlHistoryActions.refreshDataItem(item));
  } catch (error: unknown) {
    const { message, errorCode } = parseError(error);
    // Optionally handle errorCode - ErrorCodeEnum.FIELD_REQUIRED
    yield put(amlHistoryActions.setError(message));
  } finally {
    yield put(amlHistoryActions.setLoading(false));
  }
}

function* fetchDetailsByUid(
  action: PayloadAction<GetAmlHistoryItemRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const response: GetAmlHistoryItemResponse = yield call(
      amlbotAPI.fetchAmlHistoryItem,
      payload,
    );

    const item = amlHistoryMappers.mapAmlHistoryItem(response.data.data);
    yield put(amlHistoryActions.setDetailsItem(item));
  } catch (error: unknown) {
    const { message } = parseError(error);
    yield put(amlHistoryActions.setDetailsError(message));
  }
}

export { fetchAmlHistory, fetchHistoryItem, fetchDetailsByUid };
